import React from 'react'
import { StaticImage } from 'gatsby-plugin-image'
import { Link } from 'gatsby'
import AimFooterBottom from './AimFooterBottom'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faAngleRight } from '@fortawesome/free-solid-svg-icons'

/** @param {{ type: string, top?: string }} props */
const AimFooter = ({ type, top }) => {
  return (
    <footer className={`aimFooter  ${'aimFooter--' + type}`}>
      {top !== 'none' && (
        <section className="aimFooter__top">
          <div className="aimFooter__topInner">
            <ul className="aimFooter__contents">
              <li>
                <StaticImage src="../images/logo/aim@_footer-logo.png" className="aimFooter__logo" alt="フッターロゴ" placeholder="none" />
              </li>
              <li className="aimFooter__pageLink">
                <ul>
                  <li className="aimFooter__pageLinkItem">
                    <Link to="/aim/about">
                      <span className="aimFooter__textArrow">
                        <FontAwesomeIcon icon={faAngleRight} className="aimFooter__textArrowIcon" />
                      </span>
                      <p>aim@の特長</p>
                    </Link>
                  </li>
                  <li className="aimFooter__pageLinkItem">
                    <Link to="/aim/success">
                      <span className="aimFooter__textArrow">
                        <FontAwesomeIcon icon={faAngleRight} className="aimFooter__textArrowIcon" />
                      </span>
                      <p>成功事例</p>
                    </Link>
                  </li>
                  <li className="aimFooter__pageLinkItem">
                    <Link to="/aim/blog">
                      <span className="aimFooter__textArrow">
                        <FontAwesomeIcon icon={faAngleRight} className="aimFooter__textArrowIcon" />
                      </span>
                      <p>お役立ち情報</p>
                    </Link>
                  </li>
                  <li className="aimFooter__pageLinkItem">
                    <Link to="/aim/seminar">
                      <span className="aimFooter__textArrow">
                        <FontAwesomeIcon icon={faAngleRight} className="aimFooter__textArrowIcon" />
                      </span>
                      <p>セミナー</p>
                    </Link>
                  </li>
                </ul>
              </li>
              <li>
                <address>
                  <ul className="aimFooter__address">
                    <li>
                      <p>TEL：03-6233-8125</p>
                      <p className="aimFooter__addressDate">受付時間 月～金 10:00～18:00</p>
                    </li>
                    <li>app-info@mates-system.com</li>
                    <li>FAX：03-6233-8170</li>
                  </ul>
                </address>
              </li>
            </ul>
          </div>
        </section>
      )}
      <AimFooterBottom />
    </footer>
  )
}
export default AimFooter
